export const redeemModalStateInitial = {
  redeemBalance: null,
};

export const RedeemModalActionsTypes = {
  ON_REDEEM_CLICKED: 'WALLET_PAGE.REDEEM_MODAL.ON_REDEEM_CLICKED',
};
